module.exports = __webpack_public_path__ + "img/reset_wrench.83a84811.svg";